<div class="ha-substance-abuse-section section-wrapper">
	<div id="lifestyle-substance-abuse">
		<div class="heading">
			<span [translate]="'wellness.health-assessment-new.lifestyle.substance-abuse.heading'">Substabce Abuse</span>
		</div>

		<div class="form-group" [formGroup]="substanceAbuseForm">
			<div class="form-field">
				<div
					class="radio-btn-label"
					[translate]="'wellness.health-assessment-new.lifestyle.substance-abuse.form-fields.currentlySmokeCigarettes'">
					Do you currently smoke tobacco cigarettes (not e-cigarettes)?
				</div>
				<mat-radio-group
					name="currentlySmokeCigarettes"
					formControlName="currentlySmokeCigarettes"
					(change)="radioButtonChanged($event)"
					[disabled]="readOnly">
					<mat-radio-button appAutofocus [value]="true">
						<span [translate]="'wellness.health-assessment-new.lifestyle.substance-abuse.form-fields.option-yes'"
							>Yes</span
						>
					</mat-radio-button>
					<mat-radio-button [value]="false">
						<span [translate]="'wellness.health-assessment-new.lifestyle.substance-abuse.form-fields.option-no'"
							>No</span
						>
					</mat-radio-button>
				</mat-radio-group>
			</div>
			<div *ngIf="currentlySmokeCigarettes">
				<div class="form-field">
					<div
						class="radio-btn-label"
						[translate]="'wellness.health-assessment-new.lifestyle.substance-abuse.form-fields.yearsOfSmoking'">
						How many years have you been smoking?
					</div>
					<mat-form-field appearance="fill">
						<input matInput formControlName="yearsOfSmoking" [readonly]="readOnly" />
					</mat-form-field>
				</div>
				<div class="form-field">
					<div
						class="radio-btn-label"
						[translate]="'wellness.health-assessment-new.lifestyle.substance-abuse.form-fields.cigarettesPerDay'">
						How many tobacco cigarettes per day do you smoke?
					</div>
					<mat-form-field appearance="fill">
						<input matInput formControlName="cigarettesPerDay" [readonly]="readOnly" />
					</mat-form-field>
				</div>
			</div>

			<div *ngIf="currentlySmokeCigarettes === false">
				<div
					class="radio-btn-label"
					[translate]="'wellness.health-assessment-new.lifestyle.substance-abuse.form-fields.everSmokeCigarettes'">
					Did you smoke in the past?
				</div>
				<mat-radio-group
					formControlName="everSmokeCigarettes"
					name="everSmokeCigarettes"
					(change)="radioButtonChanged($event)"
					[disabled]="readOnly">
					<mat-radio-button [value]="true">
						<span [translate]="'wellness.health-assessment-new.lifestyle.substance-abuse.form-fields.option-yes'"
							>Yes</span
						>
					</mat-radio-button>
					<mat-radio-button [value]="false">
						<span [translate]="'wellness.health-assessment-new.lifestyle.substance-abuse.form-fields.option-no'"
							>No</span
						>
					</mat-radio-button>
				</mat-radio-group>

				<div *ngIf="everSmokeCigarettes">
					<div class="form-field">
						<div
							class="radio-btn-label"
							[translate]="'wellness.health-assessment-new.lifestyle.substance-abuse.form-fields.yearQuitSmoking'">
							In what year did you quit?
						</div>
						<mat-form-field appearance="fill">
							<input matInput formControlName="yearQuitSmoking" [readonly]="readOnly" />
						</mat-form-field>
					</div>
					<div class="form-field">
						<div
							class="radio-btn-label"
							[translate]="
								'wellness.health-assessment-new.lifestyle.substance-abuse.form-fields.yearsSmokedPreviously'
							">
							How many years did you smoke?
						</div>
						<mat-form-field appearance="fill">
							<input matInput formControlName="yearsSmokedPreviously" [readonly]="readOnly" />
						</mat-form-field>
					</div>
					<div class="form-field">
						<div
							class="radio-btn-label"
							[translate]="
								'wellness.health-assessment-new.lifestyle.substance-abuse.form-fields.cigarettesPerDayPreviously'
							">
							How many cigarettes did you have per day when you previously smoked?
						</div>
						<mat-form-field appearance="fill">
							<input matInput formControlName="cigarettesPerDayPreviously" [readonly]="readOnly" />
						</mat-form-field>
					</div>
				</div>
			</div>

			<div
				class="radio-btn-label"
				[translate]="'wellness.health-assessment-new.lifestyle.substance-abuse.form-fields.smokedEcigarettesPastYear'">
				Have you smoked e-cigarettes in the past year?
			</div>
			<mat-radio-group
				formControlName="smokedEcigarettesPastYear"
				name="smokedEcigarettesPastYear"
				(change)="radioButtonChanged($event)"
				[disabled]="readOnly">
				<mat-radio-button [value]="true">
					<span [translate]="'wellness.health-assessment-new.lifestyle.substance-abuse.form-fields.option-yes'"
						>Yes</span
					>
				</mat-radio-button>
				<mat-radio-button [value]="false">
					<span [translate]="'wellness.health-assessment-new.lifestyle.substance-abuse.form-fields.option-no'">No</span>
				</mat-radio-button>
			</mat-radio-group>

			<div *ngIf="smokedEcigarettesPastYear">
				<div>
					<div
						class="radio-btn-label"
						[translate]="
							'wellness.health-assessment-new.lifestyle.substance-abuse.form-fields.concernedAboutEcigaretteUse'
						">
						How concerned are you about your e-cigarette use?
					</div>
					<div class="slider">
						<div class="slider-labels">
							<span class="label-left">{{ concernLookupValues[0]?.name }}</span>
							<span class="label-right">{{ concernLookupValues[concernLookupValues.length - 1]?.name }}</span>
						</div>
						<mat-slider
							[disabled]="readOnly"
							[max]="concernSlider.max"
							[min]="concernSlider.min"
							[step]="concernSlider.step"
							[showTickMarks]="true">
							<input matSliderThumb formControlName="concernedAboutEcigaretteUse" />
						</mat-slider>
					</div>
				</div>
			</div>

			<div class="form-field slider-group-with-label">
				<div class="radio-btn-label">
					<span
						[translate]="
							'wellness.health-assessment-new.lifestyle.substance-abuse.form-fields.drinkingFrequencyPastYear'
						"
						>How often did you have a drink containing alcohol in the past year?</span
					>
				</div>
				<div class="slider-show-value-text h-70">
					<div class="slider-labels">
						<span class="label-value-text">
							{{ getAlcoholFreqValue(substanceAbuseForm.get('drinkingFrequencyPastYear').value) }}
						</span>
					</div>
					<mat-slider
						[disabled]="readOnly"
						[max]="drinkingFrequencyPastYearSlider.max"
						[min]="drinkingFrequencyPastYearSlider.min"
						[step]="drinkingFrequencyPastYearSlider.step"
						[showTickMarks]="true">
						<input
							matSliderThumb
							formControlName="drinkingFrequencyPastYear"
							[(ngModel)]="substanceAbuseData.drinkingFrequencyPastYear" />
					</mat-slider>
				</div>
			</div>
			<div class="form-field slider-group-with-label">
				<div class="radio-btn-label">
					<span
						[translate]="'wellness.health-assessment-new.lifestyle.substance-abuse.form-fields.drinksPerDayPastYear'"
						>How many drinks did you have on a typical day when you were drinking in the past year?</span
					>
				</div>
				<div class="slider-show-value-text">
					<div class="slider-labels">
						<span class="label-value-text">
							{{ getDrinksPerDayPastYearValue(substanceAbuseForm.get('drinksPerDayPastYear').value) }}
						</span>
					</div>
					<mat-slider
						[disabled]="readOnly"
						[max]="drinksPerDayPastYearSlider.max"
						[min]="drinksPerDayPastYearSlider.min"
						[step]="drinksPerDayPastYearSlider.step"
						[showTickMarks]="true">
						<input
							matSliderThumb
							formControlName="drinksPerDayPastYear"
							[(ngModel)]="substanceAbuseData.drinksPerDayPastYear" />
					</mat-slider>
				</div>
			</div>
			<div class="form-field slider-group-with-label">
				<div class="radio-btn-label">
					<span
						[translate]="
							'wellness.health-assessment-new.lifestyle.substance-abuse.form-fields.drinksMoreThanSixPastYear'
						"
						>How often did you have six or more drinks on one occasion in the past year?</span
					>
				</div>
				<div class="slider-show-value-text h-70">
					<div class="slider-labels">
						<span class="label-value-text">
							{{ getDrinksMoreThanSixValue(substanceAbuseForm.get('drinksMoreThanSixPastYear').value) }}
						</span>
					</div>
					<mat-slider
						[disabled]="readOnly"
						[max]="drinksMoreThanSixPastYearSlider.max"
						[min]="drinksMoreThanSixPastYearSlider.min"
						[step]="drinksMoreThanSixPastYearSlider.step"
						[showTickMarks]="true">
						<input
							matSliderThumb
							formControlName="drinksMoreThanSixPastYear"
							[(ngModel)]="substanceAbuseData.drinksMoreThanSixPastYear" />
					</mat-slider>
				</div>
			</div>

			<div class="form-field">
				<div
					class="radio-btn-label"
					[translate]="'wellness.health-assessment-new.lifestyle.substance-abuse.form-fields.usedMarijuanaPastYear'">
					Have you used marijuana in the past year?(smoked, vaped, eaten)
				</div>
				<mat-radio-group
					name="usedMarijuanaPastYear"
					formControlName="usedMarijuanaPastYear"
					(change)="radioButtonChanged($event)"
					[disabled]="readOnly">
					<mat-radio-button [value]="true">
						<span [translate]="'wellness.health-assessment-new.lifestyle.substance-abuse.form-fields.option-yes'"
							>Yes</span
						>
					</mat-radio-button>
					<mat-radio-button [value]="false">
						<span [translate]="'wellness.health-assessment-new.lifestyle.substance-abuse.form-fields.option-no'"
							>No</span
						>
					</mat-radio-button>
				</mat-radio-group>
			</div>
			<div *ngIf="usedMarijuanaPastYear">
				<div class="form-field slider-group">
					<div class="radio-btn-label question-label">
						<span
							[translate]="
								'wellness.health-assessment-new.lifestyle.substance-abuse.form-fields.concernedAboutMarijuanaUse'
							"
							>How concerned are you about your marijuana use?</span
						>
					</div>
					<div class="slider">
						<div class="slider-labels">
							<span class="label-left">{{ concernLookupValues[0]?.name }}</span>
							<span class="label-right">{{ concernLookupValues[concernLookupValues.length - 1]?.name }}</span>
						</div>
						<mat-slider
							[disabled]="readOnly"
							[max]="concernSlider.max"
							[min]="concernSlider.min"
							[step]="concernSlider.step"
							[showTickMarks]="true">
							<input matSliderThumb formControlName="concernedAboutMarijuanaUse" />
						</mat-slider>
					</div>
				</div>
			</div>

			<div class="form-field">
				<div
					class="radio-btn-label"
					[translate]="
						'wellness.health-assessment-new.lifestyle.substance-abuse.form-fields.recreationalDrugsPastYear'
					">
					Have you used any other recreational drugs in the past year?(cocaine, heroin, meth, etc.)
				</div>
				<mat-radio-group
					name="recreationalDrugsPastYear"
					formControlName="recreationalDrugsPastYear"
					(change)="radioButtonChanged($event)"
					[disabled]="readOnly">
					<mat-radio-button [value]="true">
						<span [translate]="'wellness.health-assessment-new.lifestyle.substance-abuse.form-fields.option-yes'"
							>Yes</span
						>
					</mat-radio-button>
					<mat-radio-button [value]="false">
						<span [translate]="'wellness.health-assessment-new.lifestyle.substance-abuse.form-fields.option-no'"
							>No</span
						>
					</mat-radio-button>
				</mat-radio-group>
			</div>
			<div *ngIf="recreationalDrugsPastYear">
				<div class="form-field slider-group">
					<div class="radio-btn-label question-label">
						<span
							[translate]="'wellness.health-assessment-new.lifestyle.substance-abuse.form-fields.concernedAboutDrugUse'"
							>How concerned are you about your drug use?</span
						>
					</div>
					<div class="slider">
						<div class="slider-labels">
							<span class="label-left">{{ concernLookupValues[0]?.name }}</span>
							<span class="label-right">{{ concernLookupValues[concernLookupValues.length - 1]?.name }}</span>
						</div>
						<mat-slider
							[disabled]="readOnly"
							[max]="concernSlider.max"
							[min]="concernSlider.min"
							[step]="concernSlider.step"
							[showTickMarks]="true">
							<input matSliderThumb formControlName="concernedAboutDrugUse" />
						</mat-slider>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div *ngIf="!readOnly" class="save-btn {{ readOnly ? 'read-only' : '' }}" (click)="next()">
		<button class="button button-medium" mat-button>
			<span *ngIf="returningUser" [translate]="'wellness.health-assessment-new.update-button'">Update</span>
			<span *ngIf="!returningUser" [translate]="'wellness.health-assessment-new.next-button'">Next</span>
		</button>
	</div>
</div>
